<template>
  <div class="sub-routes">
    <section class="section"
             id="objectList">
      <el-tabs type="border-card"
               v-model="tabChoosed"
               @tab-click="changeTabs">
        <el-tab-pane label="活跃对象">
          <el-table border
                    body="true"
                    v-loading="loading"
                    :data="tableData"
                    row-class-name="cursor-pointer"
                    size="small"
                    :default-sort="{ prop: 'date', order: 'ascending' }"
                    style="width: 100%;font-size: 14px;"
                    @row-click="lookObject"
                    @sort-change="sortChange">
            <el-table-column align='center'
                             min-width="110"
                             prop="created_time"
                             label="创建时间"
                             sortable="custom">
              <template slot-scope="scope">
                <div>{{ scope.row.created_time }}</div>
              </template>
            </el-table-column>
            <el-table-column align='center'
                             min-width="130"
                             prop="follow_person_name"
                             label="对象名称"></el-table-column>
            <el-table-column align='center'
                             min-width="110"
                             prop="start_dept_name"
                             label="创建部门"
                             sortable="custom"></el-table-column>
            <el-table-column align='center'
                             min-width="120"
                             prop="remark"
                             label="详细描述"></el-table-column>
            <el-table-column align='center'
                             min-width="150"
                             prop="task_name"
                             label="关联随访任务">
              <template slot-scope="scope">
                <el-popover class="task_name"
                            placement="top-start"
                            width="200"
                            trigger="hover"
                            :content="scope.row.task_name">
                  <div slot="reference">{{ scope.row.task_name }}</div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column align='center'
                             min-width="100"
                             prop="operation"
                             label="操作">
              <template slot-scope="scope">
                <el-button @click.stop="handleClick(scope.row.id)"
                           type="text"
                           size="medium">冻结</el-button>
                <el-button @click.stop="lookObject(scope.row)"
                           type="text"
                           size="medium">查看</el-button>
                <el-button v-if="scope.row.task_name == null"
                           @click.stop="updateObject(scope.row)"
                           type="text"
                           size="medium">修改</el-button>
              </template>
            </el-table-column>
          </el-table>

          <!--分页-->
          <div class="font-r pad-top10"
               v-show="tableData.length != 0">
            <el-pagination background
                           @current-change="handleCurrentChange"
                           @size-change="handleSizeChange"
                           :current-page.sync="currentPage"
                           :page-sizes="[5, 10]"
                           :total="total"
                           layout="total, prev, pager, next"></el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="历史对象">
          <el-table border
                    body="true"
                    v-loading="loadings"
                    :data="tableDataHistory"
                    row-class-name="cursor-pointer"
                    size="small"
                    :default-sort="{ prop: 'date', order: 'descending' }"
                    style="width: 100%;font-size: 14px;"
                    @row-click="lookObject"
                    @sort-change="sortChangeHis">
            <el-table-column align='center'
                             min-width="110"
                             prop="created_time"
                             label="创建时间"
                             sortable="custom">
              <template slot-scope="scope">
                <div>{{ scope.row.created_time }}</div>
              </template>
            </el-table-column>
            <el-table-column align='center'
                             min-width="130"
                             prop="follow_person_name"
                             label="对象名称"></el-table-column>
            <el-table-column align='center'
                             min-width="110"
                             prop="start_dept_name"
                             label="创建部门"
                             sortable="custom"></el-table-column>
            <el-table-column align='center'
                             min-width="120"
                             prop="remark"
                             label="详细描述"></el-table-column>
            <el-table-column align='center'
                             min-width="150"
                             prop="task_name"
                             label="关联随访任务">
              <template slot-scope="scope">
                <el-popover class="task_name"
                            placement="top-start"
                            width="200"
                            trigger="hover"
                            :content="scope.row.task_name">
                  <div slot="reference">{{ scope.row.task_name }}</div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column align='center'
                             min-width="100"
                             prop="operation"
                             label="操作">
              <template slot-scope="scope">
                <el-button @click.stop="handleClickHis(scope.row.id)"
                           type="text"
                           size="medium">激活</el-button>
                <el-button @click.stop="lookObject(scope.row)"
                           type="text"
                           size="medium">查看</el-button>
                <el-button @click.stop="updateObject(scope.row)"
                           type="text"
                           size="medium">修改</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!--分页-->
          <div class="font-r pad-top10"
               v-show="tableDataHistory.length != 0">
            <el-pagination background
                           @current-change="handleCurrentChangeHis"
                           @size-change="handleSizeChangeHis"
                           :current-page.sync="currentPageHis"
                           :page-sizes="[5, 10]"
                           :total="totalHis"
                           layout="total, prev, pager, next"></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </section>
  </div>
</template>

<script>
import { Message, MessageBox } from 'element-ui'
// import { get, post } from '../../../utils/requst'
import { mapMutations, mapState } from 'vuex'
import route from '../../route/config'

let qs = require('qs')
export default {
  name: 'objectList',
  //   mixins: [preventBack], //注入
  data() {
    return {
      tabChoosed: '0',
      tableData: [],
      tableDataHistory: [],
      total: 0,
      currentPage: 1,
      page: 1,
      size: 10,
      length: '',
      totalHis: 0,
      currentPageHis: 1,
      pageHis: 1,
      sizeHis: 10,
      lengthHis: '',
      loading: false,
      loadings: false,
      sort: '',
      sortHis: '',
      dept_sort: '',
      dept_sortHis: '',
    }
  },
  components: {
    //     Scroll,
  },
  //   computed: mapState(['objectList']),

  methods: {
    changeTabs(tab, event) {
      //       this.$store.commit('setObjectListPage', 1)
      this.page = 1
      this.pageHis = 1
      this.currentPage = 1
      this.currentPageHis = 1
      console.log()
      if (tab.index == 0) {
        this.getHotList()
      } else {
        this.getHistoryList()
      }
    },
    formatter(row, column) {
      return row.address
    },
    createNewObject() {
      this.$router.push({
        name: 'createNewObject',
      })
    },

    getHotList() {
      let self = this
      if (!this.tableData.length) {
        self.loading = true
      }
      let query = {
        status: 0,
        page_start: self.page,
        page_size: self.size,
        time_sort: self.sort,
        dept_sort: self.dept_sort,
      }

      self.$utils.caringRequest({
        method: 'get',
        url:
          self.$utils.getInterface('OBJECT_LIST') + '?' + qs.stringify(query),
        success: (res) => {
          self.loading = false
          if (res.code == '0') {
            self.tableData = res.data.data_list
            //     this.$store.commit('setObjectList', res.data.data_list)
            self.length = self.tableData.length
            self.total = res.data.total
            this.page = this.$store.state.objectListPage
          } else {
            Message.warning({
              message: res.message,
            })
          }
        },
      })
    },
    getHistoryList() {
      let self = this
      self.loadings = true
      let query = {
        status: 1,
        page_start: self.page,
        page_size: self.sizeHis,
        time_sort: self.sortHis,
        dept_sort: self.dept_sortHis,
      }

      self.$utils.caringRequest({
        method: 'get',
        url:
          self.$utils.getInterface('OBJECT_LIST') + '?' + qs.stringify(query),
        success: (res) => {
          console.log(res)
          self.loadings = false
          if (res.code == '0') {
            self.tableDataHistory = res.data.data_list
            self.lengthHis = self.tableDataHistory.length
            self.totalHis = res.data.total
            //     this.pageHis = this.$store.state.objectListPage
          } else {
            Message.warning({
              message: res.message,
            })
          }
        },
      })
    },

    // 移出活跃列表
    handleClick(id) {
      let self = this
      MessageBox.confirm('是否确认移出活跃列表', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      })
        .then(() => {
          let query = {
            id: id,
          }
          self.$utils
            .caringRequest({
              method: 'get',
              url:
                self.$utils.getInterface('UPDATE_STATUS') +
                '?' +
                qs.stringify(query),
            })
            .then((res) => {
              console.log(res)
              self.loadings = false
              if (res.data.code == '0') {
                Message.success({
                  message: '移出成功',
                })
                self.getHotList()
                self.getHistoryList()
              } else {
                Message.warning({
                  message: res.data.message,
                })
              }
            })
        })
        .catch(() => {})
    },

    // 移出历史列表
    handleClickHis(id) {
      console.log(id)
      let self = this
      MessageBox.confirm('是否确认移出历史列表', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      })
        .then(() => {
          let query = {
            id: id,
          }
          self.$utils
            .caringRequest({
              method: 'get',
              url:
                self.$utils.getInterface('UPDATE_STATUS') +
                '?' +
                qs.stringify(query),
            })
            .then((res) => {
              console.log(res)
              self.loadings = false
              if (res.data.code == '0') {
                Message.success({
                  message: '移出成功',
                })
                self.getHotList()
                self.getHistoryList()
              } else {
                Message.warning({
                  message: res.data.message,
                })
              }
            })
        })
        .catch(() => {})
    },

    // 查看详情
    lookObject(row) {
           
      this.$store.commit('setAllSelectedKeys', {
        type: 'add',
        name: 'createNewObject',
        title: '查看随访对象',
        key:`createNewObject?${row.id+'read'}`,
        extra: {
          id: row.id,
          type: 'read-only',
        },
      })
     
    },

    // 修改对象
    updateObject(row) {
      this.$store.commit('setAllSelectedKeys', {
        type: 'add',
        name: 'createNewObject',
        title: '修改随访对象',
        key: `createNewObject?${row.id}`,
        extra: {
          id: row.id,
          type: 'modify',
        },
      })
    },

    //列表分页点击第几页
    handleCurrentChange(val) {
      this.page = val
      this.$store.commit('setObjectListPage', val)
      this.tableData = []
      this.getHotList()
    },
    //列表点击每页多少条数据
    handleSizeChange(val) {
      this.size = val
      this.tableData = []
      this.getHotList()
    },
    //列表分页点击第几页
    handleCurrentChangeHis(val) {
      this.$store.commit('setObjectListPage', val)

      this.pageHis = val
      this.tableDataHistory = []
      this.getHistoryList()
    },
    //列表点击每页多少条数据
    handleSizeChangeHis(val) {
      this.sizeHis = val
      this.tableDataHistory = []
      this.getHistoryList()
    },

    sortChange(row) {
      console.log(row)
      //1 desc 大 到小
      // 2 asc 小到大
      if (row.column.property == 'created_time') {
        if (row.order == 'ascending') {
          this.sort = 2
          this.dept_sort = ''
        } else {
          this.sort = 1
          this.dept_sort = ''
        }
      } else {
        if (row.order == 'ascending') {
          this.dept_sort = 2
          this.sort = ''
        } else {
          this.dept_sort = 1
          this.sort = ''
        }
      }
      this.getHotList()
    },

    sortChangeHis(row) {
      console.log(row)
      //1 desc 大 到小
      // 2 asc 小到大
      if (row.column.property == 'created_time') {
        if (row.order == 'ascending') {
          this.sortHis = 2
          this.dept_sortHis = ''
        } else {
          this.sortHis = 1
          this.dept_sortHis = ''
        }
      } else {
        if (row.order == 'ascending') {
          this.dept_sortHis = 2
          this.sortHis = ''
        } else {
          this.dept_sortHis = 1
          this.sortHis = ''
        }
      }
      this.getHistoryList()
    },
  },
  mounted() {
    //     this.tabChoosed = this.$store.state.objectListTab
    //     this.bus.$on('permissions', (item) => {
    //       if (this.tabChoosed == 0) {
    //         this.getHotList()
    //       } else {
    //         this.getHistoryList()
    //       }
    //     })
    //     if (this.tabChoosed == 0) {
    //       //       this.getHotList()
    //     } else {
    //       //       this.getHistoryList()
    //     }
    //
    //
  },
  beforeDestroy() {
    //     this.bus.$off('permission')
  },
  created() {
    //     this.tableData = this.objectList
    this.getHotList()
    this.getHistoryList()
  },
}
</script>
<style lang="less" scoped>
// @import '../../../assets/common.scss';

#objectList {
  // padding: 20px;
  //   background-color: $background-color;
  .el-table {
    margin-top: 15px;
    th,
    td {
      text-align: center;
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: rgba(115, 129, 153, 1);
    }
    th,
    tr {
      background-color: none !important;
      text-align: center !important;
    }
  }
  .el-tabs__header {
    background-color: #d9dfec;
  }
  .el-tabs__item {
    font-weight: normal;
    color: #b3c1d3;
  }
  .el-tabs__item.is-active {
    color: #434f65;
  }
  .el-pagination {
    text-align: right;
    margin: 20px 0;
  }
  .el-table__header tr th {
    background: #e2e8f3;
  }
  .el-table--striped .el-table__body tr.el-table__row--striped td {
    background-color: #f6f8fc;
  }
}
.task_name {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
//   display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
